/* Cart drawer enhancements — free shipping bar + upsell */

(function () {
  'use strict';

  var cachedProducts = null;
  var addingFromUpsell = false;

  /* ── Free shipping progress bar ─────────────────────────────────── */
  function updateShippingBar() {
    var bar = document.querySelector('.cart-free-shipping-bar');
    if (!bar) return;

    var thresholdCents = parseInt(bar.dataset.threshold, 10);
    var barColor = bar.dataset.barColor || '#6e5f72';

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) {
          cachedProducts = null;
        }
        var total = cart.total_price;
        var remaining = Math.max(0, thresholdCents - total);
        var pct = Math.min(100, Math.round((total / thresholdCents) * 100));
        var reached = total >= thresholdCents;

        var fill = bar.querySelector('.cart-free-shipping-bar__fill');
        var msg  = bar.querySelector('.cart-free-shipping-bar__message');

        if (fill) {
          fill.style.width = pct + '%';
          var c1 = bar.dataset.barColor || '#6e5f72';
          var c2 = bar.dataset.barColor2 || c1;
          fill.style.background = 'linear-gradient(90deg, ' + c1 + ', ' + c2 + ', ' + c1 + ')';
          fill.style.backgroundSize = '200% 100%';
          fill.classList.toggle('cart-free-shipping-bar__fill--reached', reached);
        }

        if (msg) {
          if (reached) {
            msg.textContent = bar.dataset.reachedMessage || "🎉 You've unlocked free shipping!";
          } else {
            var formatted = formatMoney(remaining);
            var template = bar.dataset.message || "You're {amount} away from free shipping!";
            msg.textContent = template.replace('{amount}', formatted);
          }
        }
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    // Use Shopify's money format if available, strip currency code
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents).replace(/[A-Z]{3}\s?/g, '').trim();
    }
    return '$' + amount;
  }

  /* ── Upsell carousel ─────────────────────────────────────────────── */
  function initCarousel() {
    var track = document.getElementById('CartUpsellTrack');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.cart-upsell__card'));
    if (cards.length === 0) return;

    var currentIndex = 0;
    var prevBtn = document.querySelector('.cart-upsell__prev');
    var nextBtn = document.querySelector('.cart-upsell__next');

    track.style.transition = 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
    track.style.willChange = 'transform';
    // The wrapper div (not track.parentElement) handles overflow clipping
    var wrapper = track.closest('.cart-upsell__track-wrapper') || track.parentElement;

    function getGap() {
      return parseInt(getComputedStyle(track).gap || '10', 10);
    }

    function getCardWidth() {
      return cards[0].offsetWidth + getGap();
    }

    function getMaxIndex() {
      var containerWidth = wrapper.offsetWidth;
      var gap = getGap();
      var totalWidth = cards.reduce(function (sum, card, i) {
        return sum + card.offsetWidth + (i < cards.length - 1 ? gap : 0);
      }, 0);
      var maxScroll = Math.max(0, totalWidth - containerWidth);
      var cw = getCardWidth();
      return cw > 0 ? Math.ceil(maxScroll / cw) : 0;
    }

    function scrollTo(index) {
      var maxIndex = getMaxIndex();
      currentIndex = Math.max(0, Math.min(index, maxIndex));

      var containerWidth = wrapper.offsetWidth;
      var gap = getGap();
      var totalWidth = cards.reduce(function (sum, card, i) {
        return sum + card.offsetWidth + (i < cards.length - 1 ? gap : 0);
      }, 0);
      var maxTranslate = Math.max(0, totalWidth - containerWidth);
      var translate = Math.min(currentIndex * getCardWidth(), maxTranslate);

      track.style.transform = 'translateX(-' + translate + 'px)';
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }

    if (prevBtn) {
      prevBtn.disabled = true;
      prevBtn.addEventListener('click', function () { scrollTo(currentIndex - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { scrollTo(currentIndex + 1); });
    }

    window.addEventListener('resize', function () { scrollTo(currentIndex); });
  }

  /* ── Upsell slide-out ────────────────────────────────────────────── */
  function initSlideout() {
    var toggle   = document.getElementById('CartUpsellToggle');
    var slideout = document.getElementById('CartUpsellSlideout');
    var closeBtn = document.getElementById('CartUpsellClose');

    if (!toggle || !slideout) return;

    toggle.addEventListener('click', function () {
      var isOpen = slideout.classList.contains('is-open');
      slideout.classList.toggle('is-open', !isOpen);
      slideout.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        slideout.classList.remove('is-open');
        slideout.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
      });
    }
  }

  /* ── Upsell API fetch (recommendations / related) ───────────────── */
  function initUpsellApi() {
    var wrapper = document.getElementById('CartUpsellApiWrapper');
    if (!wrapper) return;

    var productId = wrapper.dataset.productId;
    var limit     = parseInt(wrapper.dataset.limit, 10) || 4;
    var intent    = wrapper.dataset.intent || 'related';
    var style     = wrapper.dataset.style || 'carousel';
    var heading   = wrapper.dataset.heading || 'You might also like';

    if (!productId) return;

    if (cachedProducts) {
      renderUpsell(cachedProducts, style, heading, wrapper);
      return;
    }

    function fetchAndRender(intentParam) {
      var url = '/recommendations/products.json'
              + '?product_id=' + productId
              + '&limit=' + limit
              + '&intent=' + intentParam;

      fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          var products = data.products;

          /* If complementary returns empty, fall back to related */
          if ((!products || products.length === 0) && intentParam === 'complementary') {
            fetchAndRender('related');
            return;
          }

          if (!products || products.length === 0) return;

          cachedProducts = products;
          renderUpsell(products, style, heading, wrapper);
        })
        .catch(function (err) {
          console.warn('[Cart upsell] API error:', err);
        });
    }

    fetchAndRender(intent);
  }

  function renderUpsell(products, style, heading, wrapper) {
    var isCarousel = style === 'carousel';
    var html = '';

    var cartVariantIds = Array.prototype.slice.call(
      document.querySelectorAll('[data-quantity-variant-id], [data-variant-id]')
    ).map(function (el) {
      return el.getAttribute('data-quantity-variant-id') || el.getAttribute('data-variant-id');
    }).filter(Boolean);

    if (isCarousel) {
      html += '<div class="cart-upsell cart-upsell--carousel">';
      html += '<div class="cart-upsell__header">';
      html += '<p class="cart-upsell__heading">' + heading + '</p>';
      html += '<div class="cart-upsell__nav">';
      html += '<button type="button" class="cart-upsell__prev" aria-label="Previous">&#8592;</button>';
      html += '<button type="button" class="cart-upsell__next" aria-label="Next">&#8594;</button>';
      html += '</div></div>';
      html += '<div class="cart-upsell__track-wrapper"><div class="cart-upsell__track" id="CartUpsellTrack">';
    } else {
      html += '<div class="cart-upsell cart-upsell--slideout-trigger">';
      html += '<button type="button" class="cart-upsell__toggle button button--secondary" id="CartUpsellToggle">';
      html += heading + '<span class="cart-upsell__toggle-icon">&#43;</span></button></div>';
      html += '<div class="cart-upsell__slideout" id="CartUpsellSlideout" aria-hidden="true">';
      html += '<div class="cart-upsell__slideout-inner">';
      html += '<div class="cart-upsell__slideout-header">';
      html += '<p class="cart-upsell__heading">' + heading + '</p>';
      html += '<button type="button" class="cart-upsell__slideout-close" id="CartUpsellClose" aria-label="Close">&#10005;</button>';
      html += '</div><div class="cart-upsell__slideout-grid">';
    }

    products.forEach(function (product) {
      /* featured_image is an object {src, width, height, alt} in the JSON */
      var imgSrc = '';
      if (product.featured_image) {
        imgSrc = typeof product.featured_image === 'string'
          ? product.featured_image
          : (product.featured_image.src || '');
        /* Append Shopify image size param */
        if (imgSrc) {
          imgSrc = imgSrc.split('?')[0] + '?width=200';
        }
      }

      var priceCents = product.price || 0;
      var price = '$' + (priceCents / 100).toFixed(2);
      if (window.Shopify && window.Shopify.formatMoney) {
        price = window.Shopify.formatMoney(priceCents).replace(/[A-Z]{3}\s?/g, '').trim();
      }

      var variantId = product.variants && product.variants[0] ? product.variants[0].id : '';
      var title = (product.title || '').substring(0, 40);
      var productUrl = product.url || ('/products/' + product.handle);
      var isAlreadyInCart = variantId && cartVariantIds.indexOf(variantId.toString()) !== -1;

      html += '<div class="cart-upsell__card">';
      html += '<a href="' + productUrl + '" class="cart-upsell__image-link">';
      if (imgSrc) {
        html += '<img src="' + imgSrc + '" alt="' + title + '" class="cart-upsell__image" loading="lazy" width="200" height="200">';
      }
      html += '</a><div class="cart-upsell__info">';
      html += '<a href="' + productUrl + '" class="cart-upsell__title">' + title + '</a>';
      html += '<p class="cart-upsell__price">' + price + '</p>';
      if (variantId) {
        if (isAlreadyInCart) {
          html += '<button type="button" class="cart-upsell__add button button--small" data-product-id="' + variantId + '" disabled>Added</button>';
        } else {
          html += '<button type="button" class="cart-upsell__add button button--small" data-product-id="' + variantId + '">Add to cart</button>';
        }
      }
      html += '</div></div>';
    });

    html += isCarousel ? '</div></div></div>' : '</div></div></div>';

    wrapper.innerHTML = html;

    setTimeout(function () {
      initCarousel();
      initSlideout();
    }, 50);
  }
  function initUpsellAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-upsell__add');
      if (!btn) return;

      var variantId = btn.dataset.productId;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = '...';
      addingFromUpsell = true;

      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function (parsedState) {
          btn.textContent = '✓';

          var bubbleSection = parsedState.sections && parsedState.sections['cart-icon-bubble'];
          if (bubbleSection) {
            var bubbleEl = document.getElementById('cart-icon-bubble');
            if (bubbleEl) {
              var parsed = new DOMParser().parseFromString(bubbleSection, 'text/html');
              var inner  = parsed.querySelector('.shopify-section');
              if (inner) bubbleEl.innerHTML = inner.innerHTML;
            }
          }

          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(parsedState);
          }

          // Trigger cart refresh event and update shipping bar
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          updateShippingBar();
        })
        .catch(function (err) {
          console.error('[Cart upsell] Add error:', err);
          btn.disabled = false;
          btn.textContent = 'Add to cart';
        });
    });
  }

  function hookCartDrawer() {
    if (!window.customElements || typeof customElements.get !== 'function') return;
    var CartDrawerEl = customElements.get('cart-drawer');
    if (CartDrawerEl && CartDrawerEl.prototype && !CartDrawerEl.prototype._upsellHooked) {
      CartDrawerEl.prototype._upsellHooked = true;
      var originalRenderContents = CartDrawerEl.prototype.renderContents;
      CartDrawerEl.prototype.renderContents = function (parsedState) {
        var wrapper = document.getElementById('CartUpsellApiWrapper');
        var savedHtml = (wrapper && wrapper.innerHTML.trim() !== '') ? wrapper.innerHTML : null;

        if (!addingFromUpsell) {
          cachedProducts = null;
          savedHtml = null;
        }
        addingFromUpsell = false;

        if (originalRenderContents) {
          originalRenderContents.call(this, parsedState);
        }

        if (savedHtml) {
          var newWrapper = document.getElementById('CartUpsellApiWrapper');
          if (newWrapper) {
            newWrapper.innerHTML = savedHtml;

            var cartVariantIds = Array.prototype.slice.call(
              document.querySelectorAll('[data-quantity-variant-id], [data-variant-id]')
            ).map(function (el) {
              return el.getAttribute('data-quantity-variant-id') || el.getAttribute('data-variant-id');
            }).filter(Boolean);

            var buttons = newWrapper.querySelectorAll('.cart-upsell__add');
            buttons.forEach(function (btn) {
              var vid = btn.getAttribute('data-product-id');
              if (vid && cartVariantIds.indexOf(vid.toString()) !== -1) {
                btn.disabled = true;
                btn.textContent = 'Added';
              } else {
                btn.disabled = false;
                btn.textContent = 'Add to cart';
              }
            });
          }
        }

        setTimeout(function () {
          updateShippingBar();
          if (!savedHtml) {
            initUpsellApi();
          } else {
            initCarousel();
            initSlideout();
          }
        }, 50);
      };
    }
  }

  /* ── Init ────────────────────────────────────────────────────────── */
  function init() {
    updateShippingBar();
    initCarousel();
    initSlideout();
    initUpsellApi();
    initUpsellAddToCart();
    hookCartDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when cart drawer opens (theme fires this event)
  document.addEventListener('cart-drawer:open', function () {
    setTimeout(function () {
      updateShippingBar();
      initCarousel();
      initSlideout();
      initUpsellApi();
    }, 100);
  });

  // Re-run bar update when cart changes
  document.addEventListener('cart:refresh', updateShippingBar);

  if (window.customElements && typeof customElements.whenDefined === 'function') {
    customElements.whenDefined('cart-drawer').then(hookCartDrawer);
  }
})();